import Select from 'react-select';
import { SelectLoadingMessage } from '../UI/loading';
import React, { useState, useEffect } from 'react';
import { useAoneStore } from '../../store/AoneStore';

const SearchInput = ({
  id,
  options,
  name,
  label,
  value,
  isDisabled,
  isLoading,
  isMulti,
  isClearable,
  isRtl,
  isSearchable,
  getOptionLabel,
  getOptionValue,
  customStyles,
  handleChange,
  placeholder,
  onMenuOpen,
  onMenuClose,
  menuIsOpen,
  tabIndex,
  maxMenuHeight,
  applySelectedStyles,
  classNameSelect,
  parentCustomStyles = null,
  menuPortalTarget = typeof document !== 'undefined' ? document.body : null,
  menuPlacement = 'bottom',
  menuPosition = 'fixed',
}) => {
  // Internal state to track if an option is selected
  const [isSelected, setIsSelected] = useState(!!value);

  useEffect(() => {
    // Update selected state if value changes
    setIsSelected(!!value);
  }, [value]);

  const combinedStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '35px',
      fontSize: '12px',
      border: '1px solid #bcc3c7',
      borderRadius: '5px',
      backgroundColor: 'transparent',
      boxShadow: state.isFocused
        ? '0 0 0 1px rgba(188, 195, 199, 0.75)'
        : 'none',
      '&:hover': {
        borderColor: '#bcc3c7',
      },
      ...(customStyles && customStyles.control),
    }),
    placeholder: (provided) => ({
      ...provided,
      fontSize: '14px',
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  };

  return (
    <div style={parentCustomStyles}>
      <Select
        styles={combinedStyles}
        placeholder={placeholder}
        label={label}
        id={id}
        className={'basic-single' + ' ' + classNameSelect}
        classNamePrefix="select"
        value={value}
        isDisabled={isDisabled}
        isMulti={isMulti}
        isLoading={isLoading}
        components={{ LoadingMessage: SelectLoadingMessage }}
        isClearable={isClearable}
        isRtl={isRtl}
        isSearchable={isSearchable}
        name={name}
        options={options}
        onChange={(selectedOption) => {
          setIsSelected(!!selectedOption); // Set border state based on selection
          handleChange(selectedOption);
        }}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        onMenuOpen={onMenuOpen}
        onMenuClose={onMenuClose}
        menuIsOpen={menuIsOpen}
        maxMenuHeight={maxMenuHeight}
        menuShouldScrollIntoView={false}
        menuPlacement={menuPlacement}
        menuPosition={menuPosition}
        menuPortalTarget={menuPortalTarget}
        tabIndex={tabIndex}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: '#f3f4f6',
            primary: '#ec171c',
            primary50: '#FCAEAE',
            neutral20: '#7a869a',
          },
        })}
      />
    </div>
  );
};

export default SearchInput;